import React, { useEffect } from "react";
import { Form, InputNumber, Modal } from "antd";

const PriceInputModal = ({
    open,
    loading,
    title,
    label,
    initialValue,
    onCancel,
    onSubmit,
}) => {
    const [form] = Form.useForm();

    useEffect(() => {
        if (!open) {
            form.resetFields();
            return;
        }

        form.setFieldsValue({ price: initialValue });
    }, [form, initialValue, open]);

    const handleOk = async () => {
        const values = await form.validateFields();
        await onSubmit(values.price);
    };

    return (
        <Modal
            title={title}
            open={open}
            onOk={handleOk}
            onCancel={onCancel}
            confirmLoading={loading}
            width={400}
            destroyOnClose
        >
            <Form form={form} layout="vertical" style={{ marginTop: 16 }}>
                <Form.Item name="price" label={label} rules={[{ required: true, message: "请输入价格" }]}>
                    <InputNumber min={0} step={0.01} style={{ width: "100%" }} placeholder="单价" />
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default PriceInputModal;
